import React from "react";
import ReactDOM from "react-dom/client";
import "./polyfills"; // Import polyfills first for browser compatibility
import "./index.css";
import { loadConfig } from "./utils/runtimeConfig";
import reportWebVitals from "./reportWebVitals";

console.log("starting");

// Block render until /config.json is loaded (or fallback resolves).
// loadConfig() never rejects — it falls back to baked process.env.REACT_APP_*
// values if /config.json is missing — so the .catch() here is just defensive.
// REACT_APP_PORTAL_MODE is baked at build time (CRA inlines REACT_APP_*).
// The applicant-portal image (docker/Dockerfile.applicant-portal-prod) builds
// with REACT_APP_PORTAL_MODE=applicant so this same source serves the slim
// public portal at apps.confanum.com; the admin image leaves it unset and
// mounts the full admin app at admin.confanum.com.
const PORTAL_MODE = process.env.REACT_APP_PORTAL_MODE === "applicant";

loadConfig()
  .then(() => {
    // Lazy-import the chosen root AFTER config is loaded so any module-level
    // code (or its imports) that calls getConfig() / initializes Firebase sees
    // a populated config.
    return PORTAL_MODE ? import("./ApplicantApp") : import("./App");
  })
  .then(({ default: App }) => {
    const root = ReactDOM.createRoot(document.getElementById("root"));
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    reportWebVitals();
  })
  .catch((err) => {
    console.error("[index] Fatal: failed to bootstrap app", err);
    document.body.innerHTML =
      '<pre style="padding:2rem;font-family:monospace;color:#b00">' +
      "Failed to load app config: " +
      (err && err.message ? err.message : String(err)) +
      "</pre>";
  });
